import { DBModel } from './DBModel';

export class TAGSongRequest extends DBModel {
  artist: string = '';
  title: string = '';

  owner: string = '';
  createdate: Date = new Date();

  votes: number = 1;
  played: boolean = false;

  constructor(info: any = {}) {
    super();
    this.deserialize(info);
  }

  override serialize(): any {
    var obj: any = super.serialize();

    obj.artist = this.artist;
    obj.title = this.title;

    obj.owner = this.owner;
    obj.createdate = this.createdate;

    obj.votes = this.votes;
    obj.played = this.played;

    return obj;
  }

  override deserialize(data: any) {
    super.deserialize(data);

    if (data.artist != null) this.artist = data.artist;
    if (data.title != null) this.title = data.title;

    if (data.owner != null) this.owner = data.owner;
    if (data.createdate != null) this.createdate = new Date(data.createdate);

    if (data.votes != null) this.votes = data.votes;
    if (data.played != null) this.played = data.played;
  }
}
